import { FC, useState } from 'react';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { LoginForm } from '../../components/LoginForm';
import { Types } from '../../config/Types';
import { ILoginUser } from '../../interfaces/ILoginUser';
import { IResponseError } from '../../interfaces/IResponseError';
import { Container } from '../../services/Container';
import { UserService } from '../../services/UserService';
import { ErrorHelper } from '../../utils/ErrorHelper';
import { getClassNames } from './login.styles';

export interface ILogin {
    onRegister(): void;
    onPasswordReset(): void;
}

export const Login: FC<ILogin> = ({ onRegister, onPasswordReset }) => {
    const classNames = getClassNames();
    const [error, setError] = useState('');
    const [fieldErrors, setFieldErrors] = useState<Partial<Record<keyof ILoginUser, string>>>({});

    const onLogin = async (user: ILoginUser) => {
        setError('');
        setFieldErrors({});
        try {
            const userService = Container.get(Types.userService) as UserService;
            await userService.login(user);
        } catch (e) {
            const errors = ErrorHelper.getFieldErrors(e as IResponseError);
            const mappedFieldErrors = {
                email: typeof errors.email === 'string' ? errors.email : undefined,
                password: typeof errors.password === 'string' ? errors.password : undefined
            };

            setFieldErrors(mappedFieldErrors);

            if (typeof errors.global === 'string') {
                setError(errors.global);
                return;
            }

            if (Object.values(mappedFieldErrors).some((value) => Boolean(value))) {
                setError('');
                return;
            }

            setError(ErrorHelper.getMessage(e as IResponseError));
        }
    };

    return (
        <>
            <Header>
                <h3>myGarage</h3>
            </Header>
            <div className={classNames.content}>
                <LoginForm
                    onSwitchToRegister={onRegister}
                    onLogin={onLogin}
                    error={error}
                    fieldErrors={fieldErrors}
                    onSwitchToPasswordReset={onPasswordReset}
                />
            </div>
            <Footer />
        </>
    );
};
